import type { SelectOption } from '../../lib/types';

export interface TransportFilterState {
    city: string;
    from: string;
    to: string;
}

/** Pure: filter transport options by accommodation city + date overlap. */
export function filterTransportOptions(
    options: SelectOption[],
    state: TransportFilterState
): SelectOption[] {
    if (!state.city && !state.from) return options;

    return options.filter(item => {
        if (state.city) {
            const city = item.city || '';
            if (!city.toLowerCase().includes(state.city.toLowerCase())) return false;
        }
        if (state.from && state.to) {
            const { from = '', to = '' } = item;
            if (!from || !to) return false;
            if (to < state.from || from > state.to) return false;
        }
        return true;
    });
}
